import React from "react";
import { Star } from "lucide-react";

// Skeleton loading component
function Skeleton() {
  return (
    <div className="min-w-[220px] select-none max-w-[220px] w-[65vw] sm:w-[220px] self-stretch flex flex-col animate-pulse">
      <div className="w-full">
        <div className="w-full aspect-square rounded-2xl bg-gray-200 ring ring-black/5 shadow-[0px_2px_6px_rgba(0,0,0,0.06)]" />
      </div>
      <div className="mt-3 flex flex-col flex-1">
        <div className="h-5 bg-gray-200 rounded w-3/4 mb-2" />
        <div className="h-4 bg-gray-200 rounded w-1/2 mb-2" />
        <div className="h-4 bg-gray-200 rounded w-2/3 mb-3" />
        <div className="mt-auto">
          <div className="h-8 bg-gray-200 rounded-full w-24" />
        </div>
      </div>
    </div>
  );
}

export default function PlaceCard({ place, placeApp }) {
  const displayName = placeApp?.displayName || "Unknown City";
  const primaryCollectionName = placeApp?.primaryCollection?.displayName || placeApp?.primarySubCategory?.displayName;
  const image = placeApp?.imageUrl || "https://cdn-imgix.headout.com/media/images/59d4ef22d864fbdb71574fe03f538195-7148-Rome-EntrytoColosseum-PalatineHill-RomanForum-17.jpg";
  const price = placeApp?.listingPrice;
  console.log(placeApp?.id)

  if (!place) return <Skeleton />;
  
  return (
    <div className="min-w-[220px] select-none max-w-[220px] w-[65vw] sm:w-[220px] self-stretch flex flex-col">
      <div className="w-full">
        <img
          src={image}
          alt={place.name}
          className="w-full aspect-square rounded-2xl object-cover ring ring-black/5 shadow-[0px_2px_6px_rgba(0,0,0,0.06)]"
        />
      </div>
      <div className="mt-3 flex flex-col flex-1">
        <div className="text-base font-medium truncate line-clamp-1 text-white">{primaryCollectionName}</div>
        <div className="text-xs mt-1 text-white/60 flex items-center gap-1">
          <Star className="h-3 w-3" aria-hidden="true" />
          {place.rating?.toFixed ? place.rating.toFixed(1) : place.rating}
          {price ? <span>· {price.currencyCode}</span> : null}
          {price ? <span>· {price.finalPrice}</span> : null}
        </div>
        <div className="text-white">{displayName}</div>
        <div className="mt-5">
         <a
  href="https://example.com"
  target="_blank"
  rel="noopener noreferrer"
  className="inline-flex items-center rounded-full bg-[#8000FF] text-white px-4 py-1.5 text-sm font-medium"
>
  Check availability
</a>
        </div>
      </div>
    </div>
  );
}

export { Skeleton };
